"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LN10Docs = void 0;
var LN10Docs = exports.LN10Docs = {
  name: 'LN10',
  category: 'Constants',
  syntax: ['LN10'],
  description: 'Returns the natural logarithm of 10, approximately equal to 2.302',
  examples: ['LN10', 'log(10)'],
  seealso: []
};